import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Loader2, Mail, CalendarClock } from "lucide-react";

const fmtDate = (iso) => {
  if (!iso) return "—";
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
  catch { return iso; }
};

export default function AdminGuests() {
  const [guests, setGuests] = useState(null);

  useEffect(() => {
    api.get("/admin/guests").then((r) => setGuests(r.data)).catch(() => setGuests([]));
  }, []);

  if (guests === null) return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin" style={{ color: "#B08D57" }} /></div>;

  return (
    <div data-testid="admin-guests">
      <div className="flex items-end justify-between mb-5">
        <h2 className="font-heading text-2xl">Guests</h2>
        <span className="text-sm" style={{ color: "#6B7280" }}>{guests.length} registered</span>
      </div>

      {guests.length === 0 ? (
        <p className="text-sm py-16 text-center" style={{ color: "#6B7280" }}>No registered guests yet.</p>
      ) : (
        <div className="rounded-2xl border overflow-hidden bg-white" style={{ borderColor: "#E5E7EB" }}>
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left" style={{ background: "#F3F0EA", color: "#6B7280" }}>
                <th className="px-5 py-3 font-medium">Guest</th>
                <th className="px-5 py-3 font-medium">Email</th>
                <th className="px-5 py-3 font-medium">Joined</th>
                <th className="px-5 py-3 font-medium text-center">Requests</th>
              </tr>
            </thead>
            <tbody>
              {guests.map((g) => (
                <tr key={g.user_id} className="border-t" style={{ borderColor: "#EFEBE4" }} data-testid={`guest-row-${g.user_id}`}>
                  <td className="px-5 py-3.5">
                    <div className="flex items-center gap-3">
                      {g.picture ? <img src={g.picture} alt="" className="w-8 h-8 rounded-full object-cover" /> :
                        <span className="w-8 h-8 rounded-full flex items-center justify-center text-xs" style={{ background: "#EFE7DA", color: "#B08D57" }}>{(g.name || g.email || "?").slice(0, 1).toUpperCase()}</span>}
                      <span className="font-medium" style={{ color: "#121212" }}>{g.name || "—"}</span>
                    </div>
                  </td>
                  <td className="px-5 py-3.5" style={{ color: "#374151" }}>
                    <span className="inline-flex items-center gap-1.5"><Mail className="w-3.5 h-3.5" style={{ color: "#B08D57" }} /> {g.email}</span>
                  </td>
                  <td className="px-5 py-3.5" style={{ color: "#6B7280" }}>
                    <span className="inline-flex items-center gap-1.5"><CalendarClock className="w-3.5 h-3.5" /> {fmtDate(g.created_at)}</span>
                  </td>
                  <td className="px-5 py-3.5 text-center">
                    <span className="inline-flex items-center justify-center min-w-[28px] px-2 py-1 rounded-full text-xs font-semibold" style={{ background: g.booking_count ? "#B08D57" : "#EFEBE4", color: g.booking_count ? "#fff" : "#6B7280" }}>{g.booking_count}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
